module.exports = __webpack_public_path__ + "8b6da79104bbfc412b809c982528cff9.svg";